module.exports = __webpack_public_path__ + "img/Mutant.9bee953b.gif";